import { FC } from 'react'

import styled from 'styled-components'

import { PrimaryInfoModal } from 'src/Components/PrimaryInfoModal'
import { PrimaryButton } from 'src/Components/Buttons/PrimaryButton'
import { MAX_MOBILE_WIDTH, variables } from 'src/Styled/variables'

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
`

const ModalText = styled.div`
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
`

const StyledModal = styled(PrimaryInfoModal)`
  max-width: 400px !important;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    max-width: 358px !important;
  }
`

const StyledPrimaryButton = styled(PrimaryButton)`
  font-weight: ${variables.fontWeight600};
  width: 116px;
  padding: 8px 24px;
  margin: 0 auto;
`

interface FavoriteCuratorModalProps {
  isOpen: boolean
  onClose: () => void
}

export const FavoriteCuratorModal: FC<FavoriteCuratorModalProps> = ({
  isOpen,
  onClose,
}) => (
  <StyledModal isOpen={isOpen} onClose={onClose} title='Curator saved'>
    <ModalContent>
      <ModalText>
        Your favorites list is growing! Soon you'll be able to manage it. We'll
        keep you posted when it's available.
      </ModalText>
      <StyledPrimaryButton onClick={onClose}>Got it</StyledPrimaryButton>
    </ModalContent>
  </StyledModal>
)
